export default function reducer(state = 'Featured', action) {
  switch (action.type) {
    case 'SET_MODEL_SIZE_SELECTION':
      return action.payload
    default:
      return state
  }
}
